var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBlueDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 2,
    height: 24,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.5C19 16.366 15.866 19.5 12 19.5C8.13401 19.5 5 16.366 5 12.5C5 8.63401 8.13401 5.5 12 5.5C15.866 5.5 19 8.63401 19 12.5Z",
    fill: "#2297FF",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlueDot);
export default __webpack_public_path__ + "static/media/ic_blue_dot.610c5ba89c6a0e71e62e83fe345420bc.svg";
export { ForwardRef as ReactComponent };